import { SCurvePoint } from "./RdoSCurveChart";
import { RdoCurvaSPontoApi, RdoCurvaSResponse } from "./rdoCurvaS.types";

function labelFromIso(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return iso;
  return `${m[3]}/${m[2]}`;
}

function indexByDate(pontos?: RdoCurvaSPontoApi[] | null) {
  const map = new Map<string, number>();
  (pontos || []).forEach((p) => {
    if (p?.data) map.set(p.data, Number(p.percentualAcumulado));
  });
  return map;
}

/** Une planejado + realizado por data; projecao fica null (API ainda não envia). */
export function mapRdoCurvaSToChart(
  data?: RdoCurvaSResponse | null
): SCurvePoint[] {
  if (!data) return [];
  const plan = indexByDate(data.planejado);
  const real = indexByDate(data.realizado);
  const dates = Array.from(
    new Set(Array.from(plan.keys()).concat(Array.from(real.keys())))
  ).sort();
  return dates.map((dataIso) => ({
    data: dataIso,
    semana: labelFromIso(dataIso),
    planejado: plan.has(dataIso) ? plan.get(dataIso)! : null,
    realizado: real.has(dataIso) ? real.get(dataIso)! : null,
    projecao: null,
  }));
}
